import PropTypes from 'prop-types';
import { Tab, Tabs } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { useFormContext } from '../state/form';
import { BlockResultTabList } from './BlockResultTabList';
import { BlockResultTabStatistics } from './BlockResultTabStatistics';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var TAB_RESULTS = 'results-tab';
var TAB_STATISTICS = 'statistics-tab';
export function BlockResultTabs(_ref) {
  var isTabStats = _ref.isTabStats,
      setTabStats = _ref.setTabStats;

  var _useFormContext = useFormContext(),
      data = _useFormContext.state.data;

  return !!data && /*#__PURE__*/_jsxs(Tabs, {
    activeKey: isTabStats ? TAB_STATISTICS : TAB_RESULTS,
    onSelect: function onSelect(k) {
      return setTabStats(k === TAB_STATISTICS);
    },
    id: "search-results",
    className: "tabs",
    transition: false,
    children: [/*#__PURE__*/_jsx(Tab, {
      eventKey: "results-tab",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        id: "result.tab.results"
      }),
      children: /*#__PURE__*/_jsx(BlockResultTabList, {})
    }), /*#__PURE__*/_jsx(Tab, {
      eventKey: "statistics-tab",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        id: "result.tab.statistics"
      }),
      children: /*#__PURE__*/_jsx(BlockResultTabStatistics, {})
    })]
  });
}
BlockResultTabs.propTypes = {
  isTabStats: PropTypes.bool.isRequired,
  setTabStats: PropTypes.func.isRequired
};